export interface IAttachmentContainer {
  key: string;
  attachments: IAttachment[];
  assetType: AttachmentAssetType;
  repairOrderNumber: string;
  mediaRef: string;
  jobCode: string;
  jobType: string;
  partsRequisitionId: string;
}

export interface IAttachment {
  fileName: string;
  key: string;
  lineNumber: number;
  description?: string;
  originalFileName?: string;
  refType?: string;
  refNumber?: string;
  mediaType: MediaType;
  assetType: AttachmentAssetType;

  action: AttachmentAction;
  path?: string;
  webPath?: string;
  base64Url?: string;
  mimeType?: string;

  demoUrl?: string;
}

export enum MediaType {
  Image = 0,
  Video = 1,
}

export enum AttachmentAction {
  Ignore = 'Ignore',
  Add = 'Add',
}

export enum AttachmentAssetType {
  WorkshopVehicle = 'WorkshopVehicle',
  StockUnit = 'StockUnit',
  FixedAsset = 'FixedAsset',
  Part = 'Part',
  Adhoc = 'Adhoc',
}

export const getEmptyAttachmentContainer = (attachmentType: AttachmentAssetType) => {
  return {
    key: '',
    attachments: [],
    repairOrderNumber: '',
    assetType: attachmentType,
    mediaRef: '',
    jobCode: '',
    jobType: '',
    partsRequisitionId: '',
  } as IAttachmentContainer;
};

export interface IBlobWithAttributes {
  blob: Blob;
  fileName: string;
  mimeType: string;
  path?: string;
  webPath?: string;
}

export interface IUpdateMediaAttachments {
  key: string;
  refType: string;
  refNo: string;
  info1: string;
  attachments: IAttachment[];
}
